module.exports = __webpack_public_path__ + "static/media/notification.7e583d14.svg";